//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "vipcenter",
  data(){
      return{
        select:0,
        vipList:[],
        userinfo:{}
      }
  },
  methods:{
      vip(){
        var _this=this;
        this.axios.post('/xcx/User/openUser',{dj_id:this.select}).then(res=>{
          this.$wechat.chooseWXPay({
            ...res.data.data,
            timestamp:res.data.data.timeStamp,
            success:function (cb) {
              _this.$vux.toast.text('开通成功','middle');
            },
            fail:function (err) {
              _this.$vux.toast.text('支付失败','middle');
            }
          });
        })
      }
  },
  created() {
      this.axios.post('/xcx/User/userCenter').then(res=>{
        this.vipList=res.data.data;
        this.userinfo=res.data.userInfo;
        this.select=this.vipList[0].id;
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/vipcenter/vipcenter.vue